<mat-icon
  [ngStyle]="{
    color: fillColor,
    width: size + 'px',
    height: size + 'px',
    'font-size': size + 'px'
  }"
  >facebook</mat-icon
>
